module.exports = __webpack_public_path__ + "img/hamburger.fc680791.svg";